<template>
  <div>
    <div v-if="vfd">
      <h4>Details for {{vfd.title}}</h4>
      <b-form>
        <b-form-group v-for="(field, i) in fields" :key="'field-'+i">
          <label class="field-label" for="field">{{field[1]}}</label>
          <div class="field-value">{{vfd[field[0]] || '---'}}</div>
          <hr />
        </b-form-group>
        <BFR :node="vfd.node" />
      </b-form>
    </div>
  </div>
</template>

<script>
import BFR from "./BFR.vue";

export default {
  name: "vfd",
  components: {
    BFR
  },
  props: {
    vfd: {}
  },
  data: () => ({
    loading: false,
    errors: [],
    filter: "",
    fields: [
      ["title", "Title"],
      ["manufacturer", "Manufacturer"],
      ["modelNo", "Model Number"],
      ["kwRating", "KW Rating"],
      ["hpRating", "HP Rating"],
      ["voltageRating", "Voltage Rating"],
      ["fullLoadAmps", "Full Load Amps"],
      ["partNo", "Part NO."],
      ["serialNo", "Serial NO."],
      ["otherNotes", "Other Notes"],
    ]
  }),
  methods: {}
};
</script>

<style lang="scss" scoped>
</style>
